// Import model
import { FormAction } from '../models/FormAction';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FormAction - handles JSON serialization and deserialization with type validation
 */
export class FormActionSerializer {
  /**
   * Deserializes a JSON string into a FormAction instance
   */
  static deserialize(json: string): FormAction {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FormAction instance
   */
  static fromObject(obj: any): FormAction {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FormAction');
    }


    const instance: FormAction = {
      action: obj['Action'] as string | undefined,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FormAction instances
   */
  static deserializeArray(json: string): FormAction[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FormAction instance to a JSON string
   */
  static serialize(instance: FormAction): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FormAction instance to a plain object
   */
  static toObject(instance: FormAction): any {
    return {
      'Action': instance.action,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of FormAction instances to a JSON string
   */
  static serializeArray(instances: FormAction[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
